/** Nuki allowedWeekDays bits: Mon=64 Tue=32 Wed=16 Thu=8 Fri=4 Sat=2 Sun=1 */

const JS_DAY_TO_NUKI_BIT = [1, 64, 32, 16, 8, 4, 2]; // index = Date.getDay()

export function nukiBitForJsDay(jsDay: number): number {
  return JS_DAY_TO_NUKI_BIT[jsDay] ?? 0;
}

/** Build Nuki weekday bitmask from booking start dates. Falls back to all days (127). */
export function nukiWeekdayBitmaskFromDates(dateStrings: string[]): number {
  let mask = 0;
  for (const dateStr of dateStrings) {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) continue;
    mask |= nukiBitForJsDay(d.getDay());
  }
  return mask > 0 ? mask : 127;
}

export function hebrewWeekdaysFromNukiMask(mask: number): string {
  const labels: { bit: number; label: string }[] = [
    { bit: 1, label: 'א׳' },
    { bit: 64, label: 'ב׳' },
    { bit: 32, label: 'ג׳' },
    { bit: 16, label: 'ד׳' },
    { bit: 8, label: 'ה׳' },
    { bit: 4, label: 'ו׳' },
    { bit: 2, label: 'ש׳' },
  ];
  const selected = labels.filter((l) => (mask & l.bit) !== 0).map((l) => l.label);
  return selected.length ? selected.join(', ') : 'כל הימים';
}
